import { Injectable } from '@angular/core'

import { PageInfo } from '../common'
import { ADMIN_API_ENDPOINTS } from '../common/api-endpoints'
import {
  LotNumberManagementDto,
  UpdateLotNumberManagementDto,
  LotNumberTenantOptionDto,
  ExportLotNumberManagementDto,
  PageResultDto
} from '../dto'
import { HttpService } from './http.service'

@Injectable({
  providedIn: 'root'
})
export class AdminLotNumberManagementService {

  constructor(private httpService: HttpService) {}

  public async list(
    mallId?: string,
    floorId?: string,
    search?: string,
    tenantName?: string,
    page: number = 1,
    pageSize: number = 10
  ): Promise<{ rows: LotNumberManagementDto[]; count: number; pageInfo: PageInfo }> {
    const queryParams: any = {
      limit: pageSize,
      offset: (page - 1) * pageSize
    }
    if (mallId) queryParams.mallId = mallId
    if (floorId) queryParams.floorId = floorId
    if (search) queryParams.search = search
    if (tenantName) queryParams.tenantName = tenantName

    const result = await this.httpService.get<PageResultDto<LotNumberManagementDto>>(
      `${ADMIN_API_ENDPOINTS.FLOOR_MAP_INTERACTIVE}/lot-numbers`,
      queryParams
    )

    const pageInfo = PageInfo.create()
    pageInfo.page = page
    pageInfo.pageSize = pageSize
    pageInfo.collectionSize = result.count

    return { rows: result.rows, count: result.count, pageInfo }
  }

  public async getById(id: string): Promise<LotNumberManagementDto> {
    return await this.httpService.get<LotNumberManagementDto>(
      `${ADMIN_API_ENDPOINTS.FLOOR_MAP_INTERACTIVE}/lot-numbers/${id}`
    )
  }

  public async update(id: string, data: UpdateLotNumberManagementDto): Promise<void> {
    await this.httpService.put<boolean>(
      `${ADMIN_API_ENDPOINTS.FLOOR_MAP_INTERACTIVE}/lot-numbers/${id}`,
      data
    )
  }

  public async getAvailableTenants(floorMapInteractiveId: string, lotNumberId?: string): Promise<LotNumberTenantOptionDto[]> {
    const queryParams: any = { floorMapInteractiveId }
    if (lotNumberId) queryParams.lotNumberId = lotNumberId

    return await this.httpService.get<LotNumberTenantOptionDto[]>(
      `${ADMIN_API_ENDPOINTS.FLOOR_MAP_INTERACTIVE}/offline-tenants`,
      queryParams
    )
  }

  public async exportExcel(payload: ExportLotNumberManagementDto): Promise<void> {
    const queryParams: any = {}
    if (payload.mallId) queryParams.mallId = payload.mallId
    if (payload.floorId) queryParams.floorId = payload.floorId
    if (payload.search) queryParams.search = payload.search
    if (payload.tenantName) queryParams.tenantName = payload.tenantName

    await this.httpService.get<void>(
      `${ADMIN_API_ENDPOINTS.FLOOR_MAP_INTERACTIVE}/lot-numbers/export`,
      queryParams
    )
  }
}
